import firebase from '../../../firebase'

import { splitSessionData } from '../../Conversations/middleware/conversation-subscriptions'

const db = firebase.firestore()




export const addVideoChatId = (videoChatId) => (dispatch, getState) => {

  return dispatch({
    type: 'addVideoChatId',
    videoChatId
  })

}


export const updateVideoChat = (props) => {

  var {videoChat, conversationId, user, mySessionDescription} = props;
  var conversationRef = db.collection('conversations').doc(conversationId)

  return conversationRef.get()

    .then((doc) => {

      var conversation = {
        ...doc.data(),
        id: doc.id
      }

      var {messages} = conversation;

      var updadateMessages = mapVideoChatUpdate({
        ...props,
        messages
      })

      return {
        ...conversation,
        messages: updadateMessages
      }
    })

    .then((updatedConversation) => {
      console.log('in updateVideoChat', {
        updatedConversation
      })
      return conversationRef.update(updatedConversation)
    })

}

var mapVideoChatUpdate = (props) => {

  var {messages, user, mySessionDescription} = props;
  var videoChatId = props.videoChat.id;

  return messages.map((message) => {
    var {videoChat} = message

    if (videoChat && videoChat.id == videoChatId) {

      var {members} = videoChat;

      var {otherSessions, mySessionSearch} = splitSessionData(members, user)

      message.videoChat.members = [...otherSessions, {
        userId: user.uid,
        sessionDescription: mySessionDescription
      }]

      return message

    }

    return message

  })

}







// WEBPACK FOOTER //
// ./src/Components/MessagingScreen/actions/videoChat.js